



































































































import {Component, Prop, Vue} from 'vue-property-decorator'
import CDLastActiveProjectCard from '@/components/communityDevelopment/CDLastActiveProjectCard.vue'
import {GithubRepositoryCollection} from '@/model/collection/GithubRepositoryCollection'
import _ from 'lodash'

@Component({
  components: {
    CDLastActiveProjectCard,
  },
})
export default class CDLastActiveProjectsSection extends Vue {
  @Prop({type: GithubRepositoryCollection, required: false, default: null})
  repositoryCollection!: GithubRepositoryCollection

  $refs!: {
    carouselList?: HTMLElement
  }

  private async restoreCarouselAndPageScroll(
    pageY: number,
    scrollLeft: number
  ) {
    const apply = () => {
      const list = this.$refs.carouselList
      if (list) {
        list.scrollLeft = scrollLeft
      }
      if (typeof window !== 'undefined') {
        window.scrollTo(0, pageY)
      }
    }

    await this.$nextTick()
    await new Promise<void>(resolve =>
      requestAnimationFrame(() => requestAnimationFrame(() => resolve()))
    )
    apply()
    setTimeout(apply, 50)
  }

  async onExpandClick(expandFn: Function = _.noop) {
    const list = this.$refs.carouselList
    const prevScrollLeft = list?.scrollLeft ?? 0
    const prevPageY =
      typeof window !== 'undefined'
        ? window.pageYOffset || document.documentElement.scrollTop
        : 0

    await expandFn()
    await this.restoreCarouselAndPageScroll(prevPageY, prevScrollLeft)
    this.$emit('viewMoreProjects')
  }
}
